import "./Header.scss";
import { useEffect, useRef, useState } from "react";
import { Menu } from "./Menu";
import { HeaderList } from "./HeaderList";
import ModalRegister from "../ModalRegister/ModalRegister";
import { Link } from "react-router-dom";
import { getApiUrl } from "../../../api/api";
import {
  getFromlocalstorage,
  saveTolocalstorage,
} from "../../../component/MaHoaDuLieu/MaHoaDuLieu";
import { useUser } from "../../../component/UserProvider/UserProvider";
import Notify from "../../../component/Notify/Notify";

function Header() {
  const [isPassword, setIsPassword] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [dangnhap, setDangnhap] = useState(
    localStorage.getItem("dangnhap") === "true"
  );

  const hasFetched = useRef(false);

  const [dataUser, setDataUser] = useState(() => {
    return JSON.parse(getFromlocalstorage("data_u"));
  });

  const { user, fetchUser } = useUser();

  useEffect(() => {
    if (dataUser && !hasFetched.current) {
      fetchUser(dataUser._id);
      hasFetched.current = true;
    }
  }, [dataUser, fetchUser]);

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const [notifyMessage, setNotifyMessage] = useState("");
  const [notifyType, setNotifyType] = useState("error");

  // Map lỗi backend sang tiếng Thái
  const translateLoginError = (error) => {
    const errorMap = {
      "Tên đăng nhập không tồn tại": "ไม่พบชื่อผู้ใช้นี้",
      "Tài khoản không tồn tại": "ไม่พบบัญชีผู้ใช้นี้",
      "Mật khẩu không chính xác": "รหัสผ่านไม่ถูกต้อง",
      "Sai mật khẩu": "รหัสผ่านไม่ถูกต้อง",
      "Tài khoản đã bị khóa": "บัญชีถูกระงับ",
      "Tài khoản bị khóa": "บัญชีถูกระงับ",
      "Đăng nhập thất bại": "เข้าสู่ระบบไม่สำเร็จ",
    };

    return errorMap[error] || error;
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    const username = e.target[0].value.trim();
    const password = e.target[1].value.trim();

    if (!username || !password) {
      setNotifyMessage("กรุณากรอกชื่อผู้ใช้และรหัสผ่าน!");
      setNotifyType("error");
      return;
    }

    try {
      const res = await fetch(`${getApiUrl("backend")}/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username,
          password,
        }),
      });

      const data = await res.json();

      if (data.error) {
        setNotifyMessage(translateLoginError(data.error));
        setNotifyType("error");
        return;
      }

      localStorage.setItem("dangnhap", "true");

      saveTolocalstorage(
        "data_u",
        JSON.stringify(data)
      );

      if (data.token) {
        localStorage.setItem("token", data.token);
      }

      setDangnhap(true);
      setDataUser(data);

      setNotifyMessage("เข้าสู่ระบบสำเร็จ!");
      setNotifyType("success");
    } catch (err) {
      console.error("เกิดข้อผิดพลาดในการเข้าสู่ระบบ:", err);

      setNotifyMessage(
        "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง!"
      );

      setNotifyType("error");
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("dangnhap");
    localStorage.removeItem("data_u");
    localStorage.removeItem("data_b");
    localStorage.removeItem("token");
    localStorage.removeItem("nganhang");

    setDangnhap(false);
    setDataUser(null);

    window.location.href = "/";
  };

  return (
    <header className="header">
      <div className="header_tong">
        <div className="header_content">
          <div className="wrap">
            {/* Logo */}
            <div className="divlogoheader">
              <img
                src="/logoheader.png"
                alt=""
              />
            </div>

            <img
              src="/newyear.png"
              className="newyear_address"
              alt=""
            />

            <div className="header_content_item">
              <div className="header_login_box">

                {/* ĐÃ ĐĂNG NHẬP */}
                {dangnhap ? (
                  <div
                    className="header_content-item logined"
                    style={{ display: "block" }}
                  >
                    <div className="member-nav">

                      {/* Username */}
                      <a
                        href="#"
                        className="member-nav__link"
                      >
                        <span className="member-nav__account">
                          <img
                            src="/account/i-account.svg"
                            alt=""
                          />
                        </span>

                        <span className="member-nav__txt username">
                          {user?.username || "---"}
                        </span>
                      </a>

                      {/* Balance */}
                      <div className="member-nav__link member-nav__link--balance">
                        <img
                          className="member-nav__icon"
                          src="/account/i-balance.svg"
                          alt=""
                        />

                        <div>
                          {user?.coins === 0
                            ? "0.00"
                            : Number(
                                (user?.coins || 0).toFixed(0)
                              ).toLocaleString("en-US") || 0}
                        </div>

                        <a
                          className="member-nav__reload"
                          href="#"
                        >
                          <img
                            src="/account/i-reload.svg"
                            alt=""
                          />
                        </a>
                      </div>

                      {/* Messages */}
                      <a
                        id="unreadMsg"
                        className="member-nav__link member-nav__link--msg active"
                        href="#"
                      >
                        <img
                          src="/account/i-message.svg"
                          alt=""
                        />

                        <span className="unread_dot"></span>
                      </a>

                      {/* Deposit */}
                      <Link
                        className="member-nav__link member-nav__btn member-nav__link--recharge"
                        to="/accounttk"
                        state={{ tab: "deposit" }}
                      >
                        <img
                          className="member-nav__icon"
                          src="/account/i-recharge.svg"
                          alt=""
                        />

                        <span>ฝากเงิน</span>
                      </Link>

                      {/* Withdraw */}
                      <Link
                        className="member-nav__link member-nav__btn member-nav__link--withdraw"
                        to="/accounttk"
                        state={{ tab: "withdraw" }}
                      >
                        <img
                          className="member-nav__icon"
                          src="/account/i-withdraw.svg"
                          alt=""
                        />

                        <span>ถอนเงิน</span>
                      </Link>

                      {/* Dropdown */}
                      <div
                        className="member-nav__drop"
                        onClick={toggleDropdown}
                      >
                        <div className="member-nav__center">
                          <Link to="/accounttk">
                            ข้อมูลส่วนตัว
                          </Link>
                        </div>

                        <div
                          className={`member-nav__dropdown ${
                            isDropdownOpen ? "active" : ""
                          }`}
                        >
                          <div className="hover-area">
                            <a onClick={handleLogout}>
                              <img
                                className="member-nav__icon"
                                src="/account/i-logout.png"
                                alt=""
                              />

                              <span>ออกจากระบบ</span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (

                  /* CHƯA ĐĂNG NHẬP */
                  <div className="header_login_box">
                    <form
                      className="member_login"
                      onSubmit={handleLogin}
                    >
                      {/* Username */}
                      <div className="member_login_field">
                        <img
                          src="/iconaccount.png"
                          alt=""
                          className="icon"
                        />

                        <input
                          type="text"
                          placeholder="ชื่อผู้ใช้"
                          maxLength={16}
                          required
                        />
                      </div>

                      {/* Password */}
                      <div className="member_login_field">
                        <img
                          src="/iconpass.png"
                          alt=""
                          className="icon"
                        />

                        <input
                          type={
                            isPassword
                              ? "password"
                              : "text"
                          }
                          placeholder="รหัสผ่าน"
                          maxLength={16}
                          required
                        />

                        <div className="toggle_eye">
                          <img
                            src={
                              isPassword
                                ? "/iconnoeye.svg"
                                : "/iconeye.svg"
                            }
                            alt=""
                            onClick={() =>
                              setIsPassword(!isPassword)
                            }
                          />
                        </div>
                      </div>

                      {/* Login */}
                      <button
                        type="submit"
                        className="member_login_btn"
                      >
                        <img
                          src="/login.svg"
                          alt=""
                        />

                        <span>เข้าสู่ระบบ</span>
                      </button>
                    </form>

                    {/* Register */}
                    <div
                      className="member_login_btn member_login_btn_register"
                      onClick={openModal}
                    >
                      <img
                        src="/register.svg"
                        alt=""
                      />

                      <span>สมัครสมาชิก</span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <Menu />
        <HeaderList />
      </div>

      {/* Register Modal */}
      {isModalOpen && (
        <div className="modal-overlay">
          <ModalRegister
            closeModal={closeModal}
          />
        </div>
      )}

      {/* Notify */}
      <Notify
        message={notifyMessage}
        type={notifyType}
        duration={3000}
        setcontent={setNotifyMessage}
      />
    </header>
  );
}

export default Header;